import React from 'react';
import { Box, Grid } from '@mui/material';
import './Shimmer.css';
import './MenuShimmer.css';

const ShimmerBox = ({ width, height, sx }) => (
    <Box className="shimmer" sx={{ width, height, ...sx }} />
);

const MenuCardShimmer = () => (
    <Box className="menu-shimmer-card">
        <ShimmerBox width="100%" height="160px" sx={{ borderBottom: '1px solid #e0e0e0' }} />
        <Box className="menu-shimmer-content">
            <ShimmerBox width="80%" height="28px" sx={{ mb: 1, mx: 'auto' }} />
            <ShimmerBox width="90%" height="40px" sx={{ mb: 2, mx: 'auto' }} />
            <Box className="menu-shimmer-details">
                <ShimmerBox width="50px" height="24px" />
                <ShimmerBox width="70px" height="24px" />
            </Box>
        </Box>
    </Box>
);

export default function RestaurantMenuShimmer() {
    return (
        <Box sx={{ py: 3 }}>
            <Grid container spacing={3}>
                {[...Array(6)].map((_, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <MenuCardShimmer />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
